import React from 'react';
import NoticeList from './NoticeList';
import { useMaintenance } from './useMaintenance';

const GENERIC_BLOCKED_NOTE = {
  state: 'active',
  mode: 'block',
  area: 'report-purchase',
  impact: 'high',
  title: 'Purchases and downloads are paused',
  message: 'We are carrying out maintenance. Please try again shortly.',
  startsAt: '1970-01-01T00:00:00.000Z',
  endsAt: null,
} as const;

/**
 * Inline notice for the buy/download controls of a report page (area
 * 'report-purchase'). Shows the window's own title and message when blocked
 * (a generic line if the server sent none), plus any banner or upcoming notice
 * scoped to purchases. The report page itself keeps working.
 */
const PurchaseMaintenanceNote: React.FC = () => {
  const { blocked, blocking, banners, upcoming } = useMaintenance('report-purchase');
  if (!blocked && banners.length === 0 && upcoming.length === 0) return null;

  const blockNotices = blocked
    ? blocking.map((n) => (n.title || n.message ? n : GENERIC_BLOCKED_NOTE))
    : [];
  return <NoticeList compact notices={[...blockNotices, ...banners, ...upcoming]} />;
};

export default PurchaseMaintenanceNote;
